export enum StatusType {
  PROCESSING = 'Processing',
  COMPLETE = 'Complete',
  ERROR = 'Error',
  IN_QUEUE = 'In Queue',
  PENDING_UPLOAD = 'Pending Upload',
  INITIALIZING = 'Initializing',
  UNPACKING = 'Unpacking',
  PENDING_REPORT_GENERATION = 'Pending Report Generation',
  INCOMPLETE = 'Incomplete',
}

export const getStatusTypeFrom = (status: string) => {
  switch (status) {
    case 'Completed':
    case 'CompletedAndEmailSent':
      return StatusType.COMPLETE;
    case 'Processing':
    case 'JobReceived':
    case 'DownloadingData':
    case 'ParsingData':
    case 'ImportingData':
    case 'AnalyzingData':
    case 'CompletedAnalyzingData':
    case 'ExcelGenerationInProgress':
    case 'ExcelJobReceived':
    case 'ExcelReportsFinished':
    case 'PowerPointJobReceived':
    case 'PowerPointInProgress':
    case 'PowerPointReportsFinished':
    case 'PreppingPowerPointViewModels':
    case 'EmailServiceJobRecieved':
      return StatusType.PROCESSING;
    case 'Unpacking':
      return StatusType.UNPACKING;
    case 'PendingUpload':
    case 'Pending':
      return StatusType.PENDING_UPLOAD;
    case 'PendingReportGeneration':
      return StatusType.PENDING_REPORT_GENERATION;
    case 'InQueue':
      return StatusType.IN_QUEUE;
    case 'Initializing':
      return StatusType.INITIALIZING;
    case 'Incomplete':
      return StatusType.INCOMPLETE;
    default:
      return StatusType.ERROR;
  }
};
